// Detect the origin of the site embedding this app in an iframe.
export function getEmbedOrigin() {
  try {
    const ao = window.location.ancestorOrigins;
    if (ao && ao.length > 0) return ao[0];
  } catch (e) {
    /* not supported */
  }
  if (document.referrer) {
    try {
      return new URL(document.referrer).origin;
    } catch (e) {
      /* invalid referrer */
    }
  }
  return "";
}

function normalizeHost(value) {
  let v = (value || "").trim().toLowerCase();
  if (!v) return "";
  if (v.includes("//")) v = v.split("//")[1];
  v = v.split("/")[0].split(":")[0];
  if (v.startsWith("www.")) v = v.slice(4);
  return v;
}

export function hostAllowed(allowedDomains, origin) {
  if (!allowedDomains || allowedDomains.length === 0) return true;
  const h = normalizeHost(origin);
  if (!h) return false;
  return allowedDomains.some((d) => {
    const nd = normalizeHost(d);
    return nd && (h === nd || h.endsWith("." + nd));
  });
}
